module.exports = __webpack_public_path__ + "img/topic2-r.7686eece.jpg";